@if (isOpen) {
  <div class="modal-backdrop" (click)="onBackdropClick($event)">
    <div class="notifications-dialog" (click)="$event.stopPropagation()">
      <h3 class="text-bosch-h3 font-bosch-strong text-bosch-gray-900 mb-bosch-md">What's New?</h3>
      @if (notifications.length > 0) {
        <div class="notifications-section mb-bosch-lg">
          @for (notification of notifications; track notification) {
            <div class="notification-item">
              <h5 class="notification-headline">{{ notification.headline }}</h5>
              <div class="notification-content" [innerHTML]="notification.content | slice:0:1000"></div>
            </div>
          }
        </div>
      }
      @if (notifications.length === 0) {
        <div class="no-notifications">
          <p class="text-sm text-bosch-gray-500">No new notifications</p>
        </div>
      }
      <button class="bg-bosch-blue-500 hover:bg-bosch-blue-600 text-white font-bosch-medium py-bosch-sm px-bosch-md rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 transition-all duration-200 text-center text-sm w-full" (click)="onClose()">Close</button>
    </div>
  </div>
}

